// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__oiK0o","selectInmate":"styles_selectInmate__MsdMw","fadeBase":"styles_fadeBase__2xaEb","fadeIn":"styles_fadeIn__A+Ga2","fadeOut":"styles_fadeOut__HRDZ7"};